import { render, staticRenderFns } from "./orderTab.vue?vue&type=template&id=f964c256&scoped=true&"
import script from "./orderTab.vue?vue&type=script&lang=js&"
export * from "./orderTab.vue?vue&type=script&lang=js&"
import style0 from "./orderTab.vue?vue&type=style&index=0&id=f964c256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f964c256",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f964c256')) {
      api.createRecord('f964c256', component.options)
    } else {
      api.reload('f964c256', component.options)
    }
    module.hot.accept("./orderTab.vue?vue&type=template&id=f964c256&scoped=true&", function () {
      api.rerender('f964c256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/orderTab.vue"
export default component.exports